import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { reducer as toastrReducer } from "react-redux-toastr";

import appReducer from "./appReducer";
import pagesReducers from "../pages/pagesReducers";
import adminReducers from "../modules/admin/adminReducers";
import systemReducers from "../modules/system/systemReducers";


const rootReducer = combineReducers({
	form: formReducer,
	toastr: toastrReducer,
	app: appReducer,
	...pagesReducers,
	...adminReducers,
	...systemReducers
});

export default rootReducer;
